import { render } from "./LayoutSimple.vue?vue&type=template&id=28f6505f"
import script from "./LayoutSimple.vue?vue&type=script&lang=js"
export * from "./LayoutSimple.vue?vue&type=script&lang=js"

import "./LayoutSimple.vue?vue&type=style&index=0&id=28f6505f&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__